import { render } from "./PattyThread.vue?vue&type=template&id=ab1106dc&scoped=true"
import script from "./PattyThread.vue?vue&type=script&lang=js"
export * from "./PattyThread.vue?vue&type=script&lang=js"

import "./PattyThread.vue?vue&type=style&index=0&id=ab1106dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab1106dc"]])

export default __exports__